import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        const elements = this.element.querySelectorAll("input,select");
        Array.from(elements).forEach(function (opt) {
            opt.setAttribute("disabled", "disabled");
        });
    }
}